module.exports = __webpack_public_path__ + "4823ac756561ab4e006d7f647755390e.ttf";